import { UserOutlined, LockOutlined, CloseOutlined } from '@ant-design/icons-vue';

export const openKeys = [ 'kpi', 'kpi-study', 'person-center' ];

const adminOrgPermission = (user, org) => {
    const { creator = false, admin = false } = org || {};
    return creator || admin;
};

// 财政局
const financeOrgPermission = (user, org) => {
    const { orgType = 0 } = org;
    return orgType === 4;
};

// budgetOrgPermission 绩效预算单位
// eslint-disable-next-line
const budgetOrgPermission = (user, org) => {
    const { orgType = 0 } = org;
    return orgType === 3;
};

// consultantOrgPermission 绩效咨询公司
// eslint-disable-next-line
const consultantOrgPermission = (user, org) => {
    const { orgType = 0 } = org;
    return orgType === 2;
};

const checkMenuPermission = (user, org, item) => {
    if (typeof item.permission === 'undefined' || !item.permission) return true;
    if (Array.isArray(item.permission) && item.permission.length > 0) {
        let b = false;
        for (const fn of item.permission) {
            b = b || fn(user, org);
        }
        return b;
    }
    if (item.permission && typeof item.permission === 'function') {
        return item.permission(user, org);
    }
    return true;
};

export const menus = [
    {
        title: '首页',
        action: '/index',
        icon: 'vxe-icon-home',
    },
    {
        title: '个人中心',
        icon: 'vxe-icon-user',
        children: [
            {
                title: '账号安全设置',
                action: '/account/security-setting',
            },
            {
                title: '修改密码',
                icon: LockOutlined,
                action: ({ changeSelfPwd }) => {
                    !!changeSelfPwd && changeSelfPwd();
                },
            },
            {
                title: '退出登录',
                icon: CloseOutlined,
                action: ({ quit }) => {
                    !!quit && quit();
                },
            },
        ],
    },
    {
        title: '系统设置',
        icon: 'vxe-icon-setting',
        name: 'person-center',
        children: [
            {
                title: '组织单位信息',
                icon: UserOutlined,
                action: '/account/org-base-info',
            },
            {
                title: '预算单位管理',
                action: '/enterprise/sys-setting/budget-org-list',
                permission: [ financeOrgPermission ],
            },
            {
                title: '合作伙伴管理',
                action: '/enterprise/sys-setting/partner-org-list',
                permission: [ consultantOrgPermission, financeOrgPermission ],
            },
            {
                title: '部门管理',
                action: '/enterprise/sys-setting/org-dep-list',
                permission: adminOrgPermission,
            },
            {
                title: '用户管理',
                action: '/enterprise/sys-setting/org-user-list',
                permission: adminOrgPermission,
            },
            {
                title: '审核流程管理',
                action: '/enterprise/sys-setting/audit-flow-cfg',
                permission: [ financeOrgPermission ],
            },
        ],
    },
    {
        title: '绩效申报表',
        icon: 'vxe-icon-signature',
        name: 'kpi-audit',
        expanded: true,
        children: [
            {
                title: '编辑中',
                action: '/kpi/proj-kpi-audit/draft-list',
                permission: [ financeOrgPermission ],
            },
            {
                title: '待提交审核',
                action: '/kpi/proj-kpi-audit/pre-audit-task-list',
                permission: financeOrgPermission,
            },
            {
                title: '待审核',
                action: '/kpi/proj-kpi-audit/fina-audit-task-list',
                permission: [ financeOrgPermission ],
            },
            {
                title: '待审核',
                action: '/kpi/proj-kpi-audit/audit-task-list',
                permission: [ consultantOrgPermission ],
            },
            {
                title: '审核中',
                action: '/kpi/proj-kpi-audit/auditing-list',
                permission: [ consultantOrgPermission, financeOrgPermission ],
            },
            {
                title: '审核完成',
                action: '/kpi/proj-kpi-audit/audited-list',
                permission: [ consultantOrgPermission, financeOrgPermission ],
            },
            {
                title: '绩效申报表管理',
                action: '/enterprise/kpi/proj-kpi/submit-kpi-list',
                permission: financeOrgPermission,
            },
        ],
    },
    {
        title: '绩效全过程',
        icon: 'vxe-icon-folder',
        name: 'kpi',
        action: '/kpi-build',
        expanded: (user, org) => {
            const { orgType = 0 } = org;
            return [ 2, 3 ].indexOf(orgType) !== -1;
        },
        children: [
            {
                title: '项目绩效申报表',
                icon: 'icon-proj-kpi',
                action: '/kpi/proj-kpi/declare/proj-list',
                permission: [ consultantOrgPermission, consultantOrgPermission, budgetOrgPermission ],
            },
            {
                title: '项目绩效监控',
                icon: 'icon-proj-monitor',
                action: '/kpi/proj-kpi/monitor/proj-list',
                permission: [ consultantOrgPermission, consultantOrgPermission, budgetOrgPermission ],
            },
            {
                title: '项目绩效自评',
                icon: 'icon-proj-appraise',
                action: '/kpi/proj-kpi/appraise/proj-list',
                permission: [ consultantOrgPermission, consultantOrgPermission, budgetOrgPermission ],
            },
        ],
    },
    {
        title: '绩效学习',
        icon: 'vxe-icon-sunny',
        name: 'kpi-study',
        expanded: false,
        children: [
            {
                title: '行业项目指标库',
                icon: 'icon-proj-kpi-search',
                action: '/kpi/proj-kpi/declare/indu-kpi-search',
            },
            {
                title: '行业部门指标库',
                icon: 'icon-dep-kpi-search',
                action: '/kpi/dep-kpi/declare/indu-kpi-search',
            },
        ],
    },
    ...(process.env.NODE_ENV === 'development'
        ? [
            {
                title: '测试表格',
                action: '/kpi-table-demo',
            },
            {
                title: '表格单位格编辑器测试',
                action: '/table-cell-input-demo',
            },
        ]
        : []),
];

export const createMenus = (user, org) => {
    const createMenuItem = (item) => {
        const { children, ...more } = item;
        // 有子项，检查子项权限
        if (children && Array.isArray(children) && children.length > 0) {
            const newChildren = [];
            for (const sub of children) {
                const subItem = createMenuItem({ ...sub });
                if (!subItem) continue;
                newChildren.push(subItem);
            }
            if (newChildren.length > 0) {
                return { ...more, children: newChildren };
            }
            // 没有子项的主菜单，不再显示
            return false;
        }
        const b = checkMenuPermission(user, org, more);
        if (!b) return false;
        return { ...more };
    };
    const items = [];
    for (const item of menus) {
        const orgMenuItem = createMenuItem({ ...item });
        if (!orgMenuItem) continue;
        const oldExpanded = orgMenuItem.expanded;
        if (typeof oldExpanded === 'function') {
            orgMenuItem.expanded = oldExpanded(user, org);
        }
        items.push(orgMenuItem);
    }
    return items;
};

